import { contains } from "./auth-service-tools454.js";

function isPortalEvent(event) {
  return !contains(event.currentTarget, event.target);
}

export { isPortalEvent };